<template>
<div>
    <div class="sb_alt_bg">
        <div class="container signin_announcements">
            <h1 class="text-uppercase text-left sb-main-header mb-5 text-center">Announcements</h1>
            <div class="row">
                <div :class="key==0 || key % 3==0?'col-md-3 sb-announcement-offset announcements-card':'col-md-3 announcements-card'" v-for="(news, key) in news_array">
                    <div class="card card_announcements">
                        <div
                            :style="'width: 100%;height: 115px;background: url(' + news.content_path + '/' + news.sco_featimg + ') center center / cover no-repeat;'">
                        </div>
                        <h4>{{ news.sco_title }}</h4>
                        <p class="pl-4 pr-4 pt-2" v-html="news.sco_summary"></p>
                        <div class="text-center signin-readnow mb-3">

                            <a
                                v-if="news.direct_link"
                                :href="news.direct_link"
                                :aria-label="'Read more about ' + news.sco_title"
                                class="btn btn-primary"
                                target="_blank"
                            >
                                {{ getBtnText(news) }}
                            </a>
                            <a
                                v-else
                                @click="readMore(news)"
                                :aria-label="'Learn more about ' + news.sco_title"
                                class="btn btn-primary"
                                href="#"
                                data-toggle="modal"
                                data-target="#alertModal"
                            >
                                {{ getBtnText(news) }}
                            </a>



<!--
                            <a v-if="news.sco_title=='INTRODUCING: SWORD Health'" class="btn btn-primary" href="https://join.swordhealth.com/compassrose" target="_blank">Learn More</a>
                            <a v-else-if="news.sco_title=='Do You Know Where To Go For Treatment?'" class="btn btn-primary" href="https://connect.compassrosebenefits.com/care-options-guide" target="_blank">Know Where to Go</a>
                            <a v-else-if="news.sco_title=='Are You A Blood Pressure Expert?'" class="btn btn-primary" href="https://connect.compassrosebenefits.com/blood-pressure" target="_blank">Get Heart Healthy</a>
                            <a v-else-if="news.sco_title=='2023 Compass Rose Health Plan Rates & Benefits'" class="btn btn-primary" href="https://connect.compassrosebenefits.com/open-season/member-2023" target="_blank">View Rates & Benefits</a>
                            <a v-else class="btn btn-primary" href="#" data-toggle="modal" @click="readMore(news)"
                               data-target="#alertModal">Read Now</a>
-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="alertModal" tabindex="-1" role="dialog" aria-labelledby="alertModalLabel"
         aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="alertModalLabel">{{ sbalert.subject }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div :style="'width: 100%; background: url(' + sbalert.photo + ') center center / contain no-repeat;'">
                    <img :src="sbalert.photo" alt="Photo" style="visibility: hidden; width: 100%;">
                </div>
                <div class="modal-body" v-html="sbalert.message">
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "SBSystemAnnouncements",
    props: [
        'announcements'
    ],
    data() {
        return {
            news_array: this.announcements,
            sbalert: {
                subject: '',
                message: '',
                photo: '',
            }
        }
    },
    methods: {
        readMore(news) {
            this.sbalert.subject = news.sco_title
            this.sbalert.message = news.sco_desc_long
            this.sbalert.photo = news.content_path + '/' + news.sco_featimg
        },
        getBtnText(news){
            if(news.button_text)
                return news.button_text
            else
                return 'Read More'
        }

    }
}
</script>

<style scoped>

</style>
